import React from "react";
import { SvgProps } from ".";

export const UploadProductionSvg: React.FC<SvgProps> = () => {
  return (
    <svg width="79px" height="72px" viewBox="0 0 79 72" version="1.1">
      <title>Upload-Production</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-414.000000, -149.000000)">
          <g
            id="Upload-Production"
            transform="translate(414.000000, 150.000000)"
          >
            <rect id="Rectangle" x="0" y="0" width="70" height="70" />
            <path
              d="M25.9281703,45.8220798 L19.4622842,45.8220798 C13.6218617,45.816507 8.30935754,42.5030434 5.82404269,37.3157681 C3.33872784,32.1284928 4.12711057,25.9993444 7.84797598,21.5810407 C11.5688414,17.162737 17.5537039,15.2490642 23.2122934,16.6682668"
              id="Path"
              stroke="#7ADFF4"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M23.2211538,22.1280305 C23.2220812,12.6703648 29.337922,4.29855917 38.347512,1.42197636 C47.357102,-1.45460645 57.1927531,1.82420527 62.6741068,9.53148774 C64.5126093,12.1165897 65.7197322,15.0009037 66.2980769,17.9783967"
              id="Path"
              stroke="#7ADFF4"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line
              x1="35.1153846"
              y1="61.9230769"
              x2="55.6153846"
              y2="61.9230769"
              id="Path"
              stroke="#1853A3"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line
              x1="35.1153846"
              y1="53.8461538"
              x2="55.6153846"
              y2="53.8461538"
              id="Path"
              stroke="#1853A3"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line
              x1="35.1153846"
              y1="45.7692308"
              x2="55.6153846"
              y2="45.7692308"
              id="Path"
              stroke="#1853A3"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line
              x1="66.6923077"
              y1="69.8269231"
              x2="66.6923077"
              y2="26.8802404"
              id="Path"
              stroke="#7ADFF4"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <polyline
              id="Path"
              stroke="#7ADFF4"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="55.6663809 37.8802404 66.6660568 26.8802404 77.6657327 37.8802404"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default {};
